// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"50ad2b22","335":"57b6fe90","336":"830e82cd","694":"2ffe120b","844":"1b310e5f","908":"98953e41"}[chunkId] + ".chunk.js";
};